import { jsx as t } from "react/jsx-runtime";
import { ContentExample as o } from "./index.es623.js";
import { TrashIcon as r } from "./index.es352.js";
import { CopyIcon as i } from "./index.es252.js";
import { ExportIcon as l } from "./index.es271.js";
import { IndexBarCell as a } from "./index.es624.js";
import { MiniBarChartCell as n } from "./index.es625.js";
import { LabelCell as c } from "./index.es626.js";
import { ColorIndicatorCell as C } from "./index.es627.js";
import { ActionCell as s } from "./index.es628.js";
import { IconCell as m } from "./index.es629.js";
import { RankingCell as _ } from "./index.es630.js";
import { SimilarityCell as E } from "./index.es631.js";
import { ParenthesisCell as T } from "./index.es632.js";
import { ColoredCell as S } from "./index.es633.js";
import { EntityCell as d } from "./index.es634.js";
import { ColorIndicatorHeader as p } from "./index.es635.js";
import { MultilineHeader as L } from "./index.es636.js";
import { IndexBarCellValueGetter as I, IndexBarCellValueSetter as u } from "./index.es637.js";
import { miniBarChartCellValueGetter as O } from "./index.es638.js";
import { labelCellValueGetter as f, labelCellValueSetter as N } from "./index.es639.js";
import { iconCellValueGetter as D, iconCellValueSetter as U } from "./index.es640.js";
import { coloredCellValueGetter as g, coloredCellValueSetter as h } from "./index.es641.js";
import { rankingCellValueGetter as b, rankingCellValueSetter as A } from "./index.es642.js";
import { similarityCellValueGetter as M, similarityCellValueSetter as R } from "./index.es643.js";
import { parenthesisCellValueGetter as H, parenthesisCellValueSetter as y } from "./index.es644.js";
import { entityCellValueGetter as x, entityCellValueSetter as V } from "./index.es645.js";
const mt = ["action", "color-indicator"], _t = ["action", "color-indicator"], Et = ["action"], Tt = [], St = ["action", "color-indicator"], dt = ["action", "color-indicator"], pt = ["label"], Lt = {
  "color-indicator": Array.from({ length: 8 }, (k, e) => (e + 1).toString())
}, It = {
  entity: d,
  colored: S,
  parenthesis: T,
  similarity: E,
  ranking: _,
  icon: m,
  action: s,
  "color-indicator": C,
  label: c,
  "mini-bar-chart": n,
  "index-bar": a
}, ut = {
  multiline: L,
  colorIndicator: p
}, Ot = {
  entity: x,
  parenthesis: H,
  similarity: M,
  ranking: b,
  colored: g,
  icon: D,
  label: f,
  "mini-bar-chart": O,
  "index-bar": I,
  // Cells With undefined as their value getter are non editable
  "color-indicator": void 0,
  action: void 0
}, ft = {
  entity: V,
  parenthesis: y,
  colored: h,
  icon: U,
  similarity: R,
  ranking: A,
  label: N,
  "index-bar": u,
  // Cells With undefined as their value setter are non editable
  "color-indicator": void 0,
  action: void 0,
  "mini-bar-chart": void 0
}, Nt = {
  entity: 250,
  trend: 100,
  "color-indicator": 50
}, Dt = { "color-indicator": 50 }, Ut = {
  standard: 48,
  comfort: 48,
  compact: 48
}, gt = { standard: 56, comfort: 84, compact: 40 }, ht = 28, bt = 28, At = {
  headerCheckboxSelection: !0,
  checkboxSelection: !0,
  showDisabledCheckboxes: !0
}, Mt = { rowDrag: !0 }, G = {
  resizable: !0,
  editable: !0,
  checkboxSelection: !0,
  filter: !0,
  rowDrag: !0,
  sortable: !0,
  wrapHeaderText: !0,
  wrapText: !0,
  pagination: { pagination: !0, paginationPageSize: 10, paginationPageSizeSelector: !1 }
}, Rt = {
  ...G,
  bulkEditable: {
    actionItems: [
      { Icon: /* @__PURE__ */ t(r, {}), onClick: () => alert("Delete"), tooltip: "Delete" },
      { Icon: /* @__PURE__ */ t(i, {}), onClick: () => alert("Copy"), tooltip: "Copy" },
      { Icon: /* @__PURE__ */ t(l, {}), onClick: () => alert("Export"), tooltip: "Export" }
    ]
  },
  pagination: { pagination: !1, paginationPageSize: 0, paginationPageSizeSelector: !1 },
  drawer: {
    header: { title: "Drawer Details", actionType: "close-help" },
    position: "right",
    width: "400px",
    height: "100%",
    children: /* @__PURE__ */ t(o, {}),
    isClosingByClickOfSameRow: !0
  }
}, Ht = {
  enableShortening: !0,
  decimalPrecision: 1
}, yt = {
  default: {
    title: "No Results Found",
    message: "There is no data available to display",
    testId: "data-grid-no-rows"
  },
  filter: {
    title: "No Results Found",
    message: "Try adjusting your search",
    buttonText: "Reset Filters",
    testId: "data-grid-no-filtered-rows"
  }
};
export {
  At as CHECKBOX_SELECTION_COLUMN,
  ht as CHECKBOX_SELECTION_COLUMN_WIDTH,
  Tt as CUSTOM_CELLS_DEFAULT_PINNED_LEFT,
  Et as CUSTOM_CELLS_DEFAULT_PINNED_RIGHT,
  dt as CUSTOM_CELLS_THAT_NOT_OPEN_DRAWER,
  St as CUSTOM_CELLS_WITH_CUSTOM_SKELETON,
  _t as CUSTOM_CELLS_WITH_NO_HEADER,
  mt as CUSTOM_CELLS_WITH_NO_INLINE_EDIT,
  pt as CUSTOM_CELLS_WITH_SELECT_INLINE_EDIT,
  Lt as CUSTOM_CELLS_WITH_SELECT_OPTIONS,
  It as CUSTOM_CELL_COMPONENTS,
  Dt as CUSTOM_CELL_MAX_WIDTH,
  Nt as CUSTOM_CELL_MIN_WIDTH,
  Ot as CUSTOM_CELL_VALUE_GETTER,
  ft as CUSTOM_CELL_VALUE_SETTER,
  ut as CUSTOM_HEADERS_COMPONENTS,
  G as DATA_GRID_TABLE_FEATURE_TRUE,
  Rt as DEFAULT_FEATURES_STATE,
  yt as DEFAULT_NO_RESULTS,
  Ht as DEFAULT_NUMERIC_CONFIGURATIONS,
  Mt as DRAG_AND_DROP_COLUMN,
  bt as DRAG_AND_DROP_COLUMN_WIDTH,
  Ut as HEADER_HEIGHTS,
  gt as ROW_HEIGHTS
};
//# sourceMappingURL=index.es531.js.map
